import type { DirectoryUser } from '../firebase/admin';

/**
 * Matching is done on the RAW strings, not on anything locale-aware.
 *
 * Phone numbers here are Western digits by project rule and names are Arabic,
 * so toLocaleLowerCase would be a no-op on one and a trap on the other. The
 * term is trimmed because a trailing space from a phone keyboard is otherwise
 * a query that matches nothing.
 */
export function filterUsers(users: DirectoryUser[], term: string): DirectoryUser[] {
  const needle = term.trim().toLowerCase();
  if (!needle) return users;
  return users.filter((u) =>
    u.displayName.toLowerCase().includes(needle) || u.phone.includes(needle));
}

/**
 * معلم first, then admins, then everyone else.
 *
 * The rows an admin is here to act on come first: revoke only appears on a
 * معلم, so a directory sorted purely by name buries every actionable row
 * under the طالب who make up almost all of it.
 *
 * Copies before sorting — sorting in place would reorder the caller's live
 * state array underneath React, which is a re-render that never happens.
 */
export function orderUsers(users: DirectoryUser[]): DirectoryUser[] {
  const rank = (u: DirectoryUser) => (u.isMuqri ? 0 : u.isAdmin ? 1 : 2);
  return [...users].sort((a, b) =>
    rank(a) - rank(b) || a.displayName.localeCompare(b.displayName, 'ar'));
}
